// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Home from './pages/Home';
import Documentos from './pages/Documentos';
import Formatos from './pages/Formatos';
import Calendario from './pages/Calendario';
import Perfil from './pages/Perfil';
import Layout from './components/Layout';
import Usuarios from './pages/Admin/Usuarios';
import Instituciones from './pages/Admin/Instituciones';
import './styles/global.css';
import Notificaciones from './pages/Notificaciones';

// Componente para rutas protegidas
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route path="/" element={
        <ProtectedRoute>
          <Layout>
            <Home />
          </Layout>
        </ProtectedRoute>
      } />

       <Route path="/documentos" element={
        <ProtectedRoute>
          <Layout>
            <Documentos />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/formatos" element={
        <ProtectedRoute>
          <Layout>
            <Formatos />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/calendario" element={
        <ProtectedRoute>
          <Layout>
            <Calendario />
          </Layout>
        </ProtectedRoute>
      } />
      
      <Route path="/perfil" element={
        <ProtectedRoute>
          <Layout>
            <Perfil />
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/admin/usuarios" element={
        <ProtectedRoute allowedRoles={['super_admin_jasp', 'admin_jasp']}>
          <Layout>
            <Usuarios />
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/admin/instituciones" element={
       <ProtectedRoute allowedRoles={['super_admin_jasp', 'admin_jasp', 'consultor_1', 'consultor_2', 'consultor_3']}>
          <Layout>
            <Instituciones />
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/notificaciones" element={
        <ProtectedRoute>
          <Layout>
            <Notificaciones />
          </Layout>
        </ProtectedRoute>
      } />
    
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
